import { render, staticRenderFns } from "./MyTtsResourcesModal.vue?vue&type=template&id=438e8c87&scoped=true"
import script from "./MyTtsResourcesModal.vue?vue&type=script&lang=js"
export * from "./MyTtsResourcesModal.vue?vue&type=script&lang=js"
import style0 from "./MyTtsResourcesModal.vue?vue&type=style&index=0&id=438e8c87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438e8c87",
  null
  
)

export default component.exports